(function () {
  if (window.__home2Theme) return;
  window.__home2Theme = true;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function markReady(el) {
    if (!el || el.dataset.home2Ready === 'true') return false;
    el.dataset.home2Ready = 'true';
    return true;
  }

  function initHeader(header) {
    if (!markReady(header)) return;

    var menuBtn = header.querySelector('[data-home2-menu-toggle]');
    var mobile = header.querySelector('.home2-header__mobile');
    var searchBtn = header.querySelector('[data-home2-search-toggle]');
    var search = header.querySelector('.home2-header__search');

    if (!header.classList.contains('is-bar') && document.querySelector('[data-home2-light-header]')) {
      header.classList.add('is-light');
    }

    function onScroll() {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    function closeSearch() {
      if (!searchBtn || !search) return;
      search.classList.remove('is-open');
      searchBtn.setAttribute('aria-expanded', 'false');
      header.classList.remove('is-search-open');
      search.setAttribute('aria-hidden', 'true');
      window.setTimeout(function () {
        if (!header.classList.contains('is-search-open')) search.hidden = true;
      }, 420);
    }

    function openSearch() {
      if (!searchBtn || !search) return;
      search.hidden = false;
      search.setAttribute('aria-hidden', 'false');
      searchBtn.setAttribute('aria-expanded', 'true');
      header.classList.add('is-search-open');
      window.requestAnimationFrame(function () {
        search.classList.add('is-open');
      });
      var input = search.querySelector('input[type="search"]');
      window.setTimeout(function () {
        if (input) input.focus();
      }, 280);
    }

    if (menuBtn && mobile) {
      menuBtn.addEventListener('click', function () {
        var open = menuBtn.getAttribute('aria-expanded') === 'true';
        menuBtn.setAttribute('aria-expanded', String(!open));
        mobile.hidden = open;
        header.classList.toggle('is-menu-open', !open);
        if (!open) closeSearch();
      });
    }

    if (searchBtn && search) {
      search.setAttribute('aria-hidden', 'true');
      searchBtn.addEventListener('click', function () {
        if (searchBtn.getAttribute('aria-expanded') === 'true') closeSearch();
        else openSearch();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && header.classList.contains('is-search-open')) {
          closeSearch();
          searchBtn.focus();
        }
      });
    }
  }

  function initSlider(root) {
    if (!markReady(root)) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-home2-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-home2-dot]'));
    if (slides.length < 2) return;

    var index = 0;
    var timer = null;
    var delay = parseInt(root.getAttribute('data-autoplay'), 10) || 0;

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function start() {
      if (delay < 1000) return;
      stop();
      timer = window.setInterval(function () {
        show(index + 1);
      }, delay);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        show(i);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    start();
  }

  function initCarousel(carousel) {
    if (!markReady(carousel)) return;

    var track = carousel.querySelector('[data-home2-carousel-track]');
    var prev = carousel.querySelector('[data-home2-carousel-prev]');
    var next = carousel.querySelector('[data-home2-carousel-next]');
    if (!track || !prev || !next) return;

    function amount() {
      var item = track.querySelector('[data-home2-carousel-item]');
      if (!item) return 300;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -amount(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: amount(), behavior: 'smooth' });
    });
  }

  function initMedia(root) {
    if (!markReady(root)) return;

    var playButton = root.querySelector('[data-home2-media-toggle]');
    var soundButton = root.querySelector('[data-home2-media-sound]');
    if (!playButton) return;

    var video = root.querySelector('video');
    var iframe = root.querySelector('iframe');
    var type = root.getAttribute('data-video-type');
    var playing = false;
    var muted = false;
    var hasEntered = false;

    root.classList.add('is-paused');
    root.classList.remove('is-muted');

    if (video) {
      video.muted = false;
      video.pause();
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
    }

    function post(payload) {
      if (!iframe || !iframe.contentWindow) return;
      iframe.contentWindow.postMessage(payload, '*');
    }

    function commandPlay(play) {
      if (video) {
        if (play) {
          var playPromise = video.play();
          if (playPromise && playPromise.catch) {
            return playPromise.catch(function () {
              return false;
            }).then(function () {
              return !video.paused;
            });
          }
          return Promise.resolve(!video.paused);
        }
        video.pause();
        return Promise.resolve(false);
      }

      if (type === 'vimeo') {
        post({ method: play ? 'play' : 'pause' });
        return Promise.resolve(play);
      }

      post(
        JSON.stringify({
          event: 'command',
          func: play ? 'playVideo' : 'pauseVideo',
          args: []
        })
      );
      return Promise.resolve(play);
    }

    function commandMute(nextMuted) {
      if (video) {
        video.muted = nextMuted;
        return;
      }

      if (type === 'vimeo') {
        post({ method: 'setVolume', value: nextMuted ? 0 : 1 });
        post({ method: 'setMuted', value: nextMuted });
        return;
      }

      post(
        JSON.stringify({
          event: 'command',
          func: nextMuted ? 'mute' : 'unMute',
          args: []
        })
      );
    }

    function syncPlayUi() {
      root.classList.toggle('is-paused', !playing);
      playButton.setAttribute('aria-label', playing ? 'Pause' : 'Play');
    }

    function syncSoundUi() {
      root.classList.toggle('is-muted', muted);
      if (soundButton) {
        soundButton.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
      }
    }

    function setPlaying(nextPlaying) {
      playing = nextPlaying;
      syncPlayUi();
      return commandPlay(playing).then(function (ok) {
        if (playing && ok === false && video && video.paused) {
          playing = false;
          syncPlayUi();
        }
        return playing;
      });
    }

    function setMuted(nextMuted) {
      muted = nextMuted;
      commandMute(muted);
      syncSoundUi();
    }

    function tryPlayWithSound() {
      setMuted(false);
      return setPlaying(true).then(function (isPlaying) {
        if (isPlaying) return true;

        // Browsers often block unmuted autoplay — fall back to muted, then play.
        setMuted(true);
        return setPlaying(true);
      });
    }

    function enterView() {
      hasEntered = true;
      tryPlayWithSound();
    }

    function leaveView() {
      if (!hasEntered) return;
      setPlaying(false);
    }

    playButton.addEventListener('click', function () {
      if (playing) {
        setPlaying(false);
        return;
      }
      tryPlayWithSound();
    });

    if (soundButton) {
      soundButton.addEventListener('click', function () {
        var nextMuted = !muted;
        setMuted(nextMuted);

        // Unmute + play after a user gesture usually succeeds.
        if (!nextMuted && !playing) {
          setPlaying(true);
        } else if (!nextMuted && playing && video) {
          video.muted = false;
          var resume = video.play();
          if (resume && resume.catch) resume.catch(function () {});
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
              enterView();
            } else if (hasEntered) {
              leaveView();
            }
          });
        },
        { threshold: [0, 0.35, 0.6] }
      );
      observer.observe(root);
    } else {
      enterView();
    }

    syncPlayUi();
    syncSoundUi();
  }

  function syncLightHeader() {
    var light = document.querySelector('[data-home2-light-header]');
    document.querySelectorAll('.home2-header').forEach(function (header) {
      if (header.classList.contains('is-bar')) return;
      header.classList.toggle('is-light', Boolean(light));
    });
  }

  function initCart(root) {
    if (!markReady(root)) return;

    function change(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function () {
        window.location.reload();
      });
    }

    root.querySelectorAll('[data-home2-cart-item]').forEach(function (item) {
      var key = item.getAttribute('data-key');
      var input = item.querySelector('.home2-cart__qty-input');
      var minus = item.querySelector('[data-home2-cart-minus]');
      var plus = item.querySelector('[data-home2-cart-plus]');
      var remove = item.querySelector('[data-home2-cart-remove]');

      if (minus && input) {
        minus.addEventListener('click', function () {
          change(key, Math.max(0, parseInt(input.value, 10) - 1));
        });
      }
      if (plus && input) {
        plus.addEventListener('click', function () {
          change(key, parseInt(input.value, 10) + 1);
        });
      }
      if (input) {
        input.addEventListener('change', function () {
          change(key, Math.max(0, parseInt(input.value, 10) || 0));
        });
      }
      if (remove) {
        remove.addEventListener('click', function () {
          change(key, 0);
        });
      }
    });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-home2-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count < 1);
    });
  }

  function initPlp(root) {
    if (!markReady(root)) return;

    var form = root.querySelector('.home2-plp__form');
    var filters = root.querySelector('[data-home2-filters]');
    var openBtn = root.querySelector('[data-home2-filters-open]');
    var closeBtn = root.querySelector('[data-home2-filters-close]');
    var sort = root.querySelector('[data-home2-sort]');
    var priceTimer = null;

    function submitForm() {
      if (!form) return;
      form.querySelectorAll('input[type="number"]').forEach(function (input) {
        if (!input.value) input.disabled = true;
      });
      form.submit();
    }

    if (form) {
      form.addEventListener('change', function (event) {
        if (event.target.matches('input[type="checkbox"], input[type="radio"]')) {
          submitForm();
        }
      });

      form.querySelectorAll('input[type="number"]').forEach(function (input) {
        input.addEventListener('change', function () {
          window.clearTimeout(priceTimer);
          priceTimer = window.setTimeout(submitForm, 350);
        });
      });
    }

    if (sort) {
      sort.addEventListener('change', submitForm);
    }

    function setFiltersOpen(open) {
      if (!filters) return;
      filters.classList.toggle('is-open', open);
      document.body.classList.toggle('home2-plp-locked', open);
    }

    if (openBtn) {
      openBtn.addEventListener('click', function () {
        setFiltersOpen(true);
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        setFiltersOpen(false);
      });
    }

    root.querySelectorAll('[data-home2-cols]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cols = btn.getAttribute('data-home2-cols');
        root.classList.remove('is-cols-2', 'is-cols-3', 'is-cols-4');
        root.classList.add('is-cols-' + cols);
        root.querySelectorAll('[data-home2-cols]').forEach(function (item) {
          item.classList.toggle('is-active', item === btn);
        });
      });
    });

    root.querySelectorAll('[data-home2-add]').forEach(function (addForm) {
      addForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var data = new FormData(addForm);
        var id = data.get('id');
        var qty = parseInt(data.get('quantity'), 10) || 1;
        var button = addForm.querySelector('button');
        if (button) button.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: qty })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return fetch('/cart.js');
          })
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            updateCartCount(cart.item_count);
          })
          .catch(function () {
            var action = addForm.getAttribute('action') || '';
            if (action && action !== '#') addForm.submit();
          })
          .finally(function () {
            if (button) button.disabled = false;
          });
      });
    });
  }

  function initPdp(root) {
    if (!markReady(root)) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-home2-pdp-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-home2-pdp-thumb]'));
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        slides.forEach(function (slide, index) {
          slide.classList.toggle('is-active', index === i);
        });
        thumbs.forEach(function (item, index) {
          item.classList.toggle('is-active', index === i);
        });
      });
    });

    var form = root.querySelector('[data-home2-pdp-form]');
    var idInput = root.querySelector('[data-home2-pdp-id]');
    var priceEl = root.querySelector('[data-home2-pdp-price]');
    var optionEls = Array.prototype.slice.call(root.querySelectorAll('[data-home2-pdp-option]'));
    var variantScript = root.querySelector('[data-home2-pdp-variants]');
    var variants = [];
    if (variantScript) {
      try {
        variants = JSON.parse(variantScript.textContent);
      } catch (err) {
        variants = [];
      }
    }

    function selectedOptions() {
      return optionEls.map(function (el) {
        return el.value;
      });
    }

    function matchVariant() {
      var values = selectedOptions();
      return variants.find(function (variant) {
        return values.every(function (value, i) {
          return variant.options[i] === value;
        });
      });
    }

    optionEls.forEach(function (el) {
      el.addEventListener('change', function () {
        var variant = matchVariant();
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (priceEl && variant.price != null) {
          var dollars = (variant.price / 100).toFixed(2);
          priceEl.textContent = '$' + dollars;
        }
      });
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        if (!idInput || !idInput.value) return;
        event.preventDefault();
        var button = form.querySelector('.home2-pdp__add');
        if (button) button.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: idInput.value, quantity: 1 })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return fetch('/cart.js');
          })
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            updateCartCount(cart.item_count);
          })
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            if (button) button.disabled = false;
          });
      });
    }
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('.home2-header').forEach(initHeader);
    root.querySelectorAll('[data-home2-slider]').forEach(initSlider);
    root.querySelectorAll('.home2-carousel').forEach(initCarousel);
    root.querySelectorAll('[data-home2-media]').forEach(initMedia);
    root.querySelectorAll('[data-home2-cart]').forEach(initCart);
    root.querySelectorAll('[data-home2-plp]').forEach(initPlp);
    root.querySelectorAll('[data-home2-pdp]').forEach(initPdp);
    syncLightHeader();
  }

  ready(function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
